import { constraints, datatypes, inputTypes } from "data/globalData";

export const tableColumns = {
	trims_id: {
		name: "Trims Id",
		key: "trims_id",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	description: {
		name: "Description",
		key: "description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	consumption: {
		name: "Consumption",
		key: "consumption",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	consumption_unit: {
		name: "Cosumption Unit",
		key: "consumption_unit",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	price: {
		name: "Price",
		key: "price",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummySewingTrimsTableData = [
	{
		id: 1,
		trims_id: "1234",
		category: "Main Label",
		description: "RAREISM RUBY LOOP MAIN LABEL WITH RED STONE LBL RR-1683-B32950-A-BLACK WITH RED -CENTER FOLD",
		consumption: 2.2,

		price: 155.0,
		value: 341,
		supplier: "MANOHAR FILAMENT",
	},
	{
		id: 2,
		trims_id: "1234",
		category: "Size Label",
		description: "RAREISM SIZE LABEL LBL-RR-1003-WS56-J (CREAM WITH BEIGE (2.8X1CM +CENTER FOLD)",
		consumption: 1.53,

		price: 92.0,
		value: 140.76,
		supplier: "MANOHAR FILAMENT",
	},
];

export const defaultTotalRow = {
	id: "TOTAL",
	trims_id: "TOTAL",
	category: "Sewing Trims",
	price: 155.0,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row.trims_id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};

export const calculateTotalRow = (allRows) => {
	let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[tableColumns.price.key])) price += +row?.[tableColumns.price.key];
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	return { ...defaultTotalRow, [tableColumns.price.key]: price, [tableColumns.value.key]: value };
};

// your base data (taken from your message)
const sewingTrimsData = [
	{
		category: "MAIN LABEL",
		description: "RAREISM LOOP MAIN LABEL WITH STONE LBL RR-782-W45614-J-CREAM WITH BEIGE (6.5X3.5 WITH CENTER FOLD)",
	},
	{ category: "SIZE LABEL", description: "RAREISM SIZE WOVEN LABEL LBL-RSM-1003" },
	{
		category: "MAIN LABEL",
		description: "RAREISM MAIN LABEL WITH STONE LBL RR-783-W45601-J-CREAM WITH BEIGE (5.3X2 WITH END FOLD)",
	},
	{ category: "SIZE LABEL", description: "RAREISM SIZE LABEL LBL-RSM-10032" },
	{ category: "ELASTIC", description: "1.5MM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "8MM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "2CM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "2.5CM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "3CM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "4CM WOVEN ELASTIC" },
	{ category: "ELASTIC", description: "5CM WOVEN ELASTIC" },
	{ category: "BUTTONS", description: "RAREISM 16L-2H BUTTON BPT- 19877" },
	{ category: "BUTTONS", description: "2H 24L TRANSPARENT PLASTIC BUTTONS" },
	{ category: "BUTTONS", description: "RAREISM 16L ROUND SHAPE SELF FABRIC BUTTONS" },
	{ category: "SNAP BUTTONS", description: "6MM PLASTIC SNAP BUTTON" },
	{ category: "OTHERS", description: "11MM METAL HOOK & I" },
	{ category: "OTHERS", description: "10MM PLASTIC RING & ADJUSTER" },
	{ category: "OTHERS", description: "10MM METAL RING & ADJUSTER" },
	{ category: "OTHERS", description: "RAREISM METAL CUT HOOK MTL-RSM-2091" },
	{ category: "TAPE", description: "6MM MOBILON TAPE / HANGER LOOP" },
	{ category: "TIPPING", description: "RAREISM METAL TIPPING MTL-RSM-2013" },
	{ category: "ZIPPER", description: "YKK INVISIBLE KNITTED ZIPPER 2 CC CHC-026 DA4Q EP V3 GUNMETAL" },
	{ category: "ZIPPER", description: "YKK NO #3 COIL CLOSED END AUTOLOCK ZIPPER WITH REGULAR PULLER" },
];

// generate numeric ID each time (ensures uniqueness per load)

let no = new Date().valueOf();

const generateNumericId = () => {
	no += 1;
	return no;
};

// format to your target structure
export const sewingTrimsPrefilledData = sewingTrimsData.map((item) => ({
	id: generateNumericId(),
	trims_id: "",
	category: item.category,
	description: item.description,
	consumption: 0,
	price: 0,
	value: 0,
	supplier: "",
}));
